jQuery(document).ready(function($){
    $('.skip-link').on('keydown', function(event) {
        if (event.key === ' ') {
            event.preventDefault();
            this.click();
        }
    });
});
